import React from 'react';
import api from './apiConnector'

class Comparateurs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            comparateurs:false
        }
    }

    componentDidMount() {
        let me = this
        api.post(
            {action:'get_comparateurs',id:this.props.devis.typedId()},
            (res)=>{
                me.setState({comparateurs:res.comparateurs})
            }
        )
    }

    renderSection(data,expand) {
        let rows = []
        for ( const field in data ) {
            if (( typeof data[field] === 'string' )||( typeof data[field] === 'number' ))  {
                let displayField = field.replace(
                    /([a-z])([A-Z])/g,
                    '$1 $2'
                )
                rows.push( <div key={field} className="details_entry"><label>{displayField}</label><span>{data[field]}</span></div> )
            } else if (( typeof data[field] === 'object' )&& expand ) {
                if ( isNaN(field) ) {
                    rows.push( <div key={field} className="details_entry"><label><b>{field}</b></label></div> )
                }
                rows.push( 
                    this.renderSection(data[field],true)
                )
            }
        }
        return rows
    }

    render() {
        const {devis} = this.props

        let adminButtons = []
        if ( api.isAdmin() ) {
            adminButtons.push(
                <a target="_blank" key="logs_tarifs" className="button" href={api.downloadTypeLogs(devis._id.$oid,'xena_tarifs')}>Logs tarifs</a>
            )
            if ( this.props.devis.params.nom ) {
                adminButtons.push(
                    <a target="_blank" key="logs_devis" className="button" href={api.downloadTypeLogs(devis._id.$oid,'xena_devis')}>Logs devis</a>
                )    
            }
        }

        return <div className="details">
            <div className="details_section"><h2>Véhicule</h2>
            {this.renderSection(this.state.comparateurs.Vehicule,true)}
            </div>
            <div className="details_section"><h2>Conducteur</h2>
            {this.renderSection(this.state.comparateurs.CondPrincipal,true)}
            </div>
            {this.state.comparateurs.CondSecondaire ? <>
                <div className="details_section"><h2>Conducteur Secondaire</h2>
                {this.renderSection(this.state.comparateurs.CondSecondaire,true)}
                </div>
            </>:<></>}
            <div className="details_section"><h2>Devis</h2>
            {this.renderSection(this.state.comparateurs,false)}
            </div>
            <div className="details_section">
                {adminButtons}
            </div>
        </div>
    }
}

export default Comparateurs;
